export function sanitizeAttrFilter(attrStr) {
    if (attrStr && _.isString(attrStr)) {
        return attrStr.replace(/[\W]/g, '-');
    }
    return attrStr;
}

export default sanitizeAttrFilter;
